type PreloadableRoute = () => Promise<any>;

const preloadedRoutes = new Set<string>();

export function preloadRoute(routeName: string, importFn: PreloadableRoute) {
  if (preloadedRoutes.has(routeName)) {
    return;
  }
  
  preloadedRoutes.add(routeName);
  
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      importFn().catch(() => {
        preloadedRoutes.delete(routeName);
      });
    });
  } else {
    setTimeout(() => {
      importFn().catch(() => {
        preloadedRoutes.delete(routeName);
      });
    }, 1);
  }
}

export function preloadCriticalRoutes() {
  const criticalRoutes = [
    { name: 'home', loader: () => import('../../core/pages/home') },
    { name: 'pricing', loader: () => import('../../core/pages/pricing') },
    { name: 'contact', loader: () => import('../../core/pages/contact') },
    { name: 'book', loader: () => import('../../core/pages/book') },
    { name: 'pest-control', loader: () => import('../../core/pages/pest-control') },
  ];
  
  criticalRoutes.forEach(({ name, loader }) => {
    preloadRoute(name, loader);
  });
}

export function createPreloadLink(routeName: string, importFn: PreloadableRoute) {
  return {
    onMouseEnter: () => preloadRoute(routeName, importFn),
    onTouchStart: () => preloadRoute(routeName, importFn),
  };
}
